<template>
  <el-form
    @submit.prevent="triggerFormSubmit"
    ref="refFormDisplay"
    :rules="modelRules"
    :model="model"
    class="common-form">
    <div class="grid-content">
      <template v-if="isMultipleDisplay">
        <div>
          <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">{{ $t("playerSetup.Progress_DisplaySettings") }}</h2>
          <div class="grid-content flex items-center gap-3 justify-center mt-20">
            <div class="flex-1">
              <display-output
                ref="output"
                :isMultipleDisplay="isMultipleDisplay"
                :output="output"
                :outputs="outputs"
                @change="model.output = $event">
              </display-output>
            </div>
            <div class="flex-1">
              <display-orientation
                ref="orientation"
                :isMultipleDisplay="isMultipleDisplay"
                :orientation="orientation"
                @change="model.orientation = $event">
              </display-orientation>
            </div>
            <div class="flex-1">
              <display-resolution
                ref="resolution"
                :resolution="resolution"
                :resolutions="resolutions"
                @change="model.resolution = $event">
              </display-resolution>
            </div>
          </div>
        </div>
        <div class="flex mt-24">
          <p class="text-xs input-hint text-center flex-1 mt-3">{{`*${$t('playerSetup.OrientationAndResolution') }`}}</p>
        </div>
      </template>
      <template v-else>
        <el-row>
          <h2 class="text-[13px] font-semibold text-[#23569F] uppercase el-col-24 leading-[1.5]">{{ $t("playerSetup.DisplayOrientation") }}</h2>
          <el-col :span="10" :offset="8">
            <div class="grid-content">
              <player-setup-form-error :message="formError" :display="formError != ''" height="short" />
              <display-orientation
              ref="orientation"
              :hasMultiOutput="hasMultiOutput"
              :orientation="model.orientation"
              @change="model.orientation = $event">
            </display-orientation>
            </div>
          </el-col>
        </el-row>
        <h2 class="text-[13px] font-semibold text-[#23569F] uppercase mt-[40px] el-col-24 leading-[1.5]">{{ $t('playerSetup.DisplayResolution') }}</h2>
        <el-row class="mt-4">
          <el-col :span="10" :offset="8">
            <display-resolution
              ref="resolution"
              :resolution="resolution"
              :resolutions="resolutions"
              @change="model.resolution = $event">
            </display-resolution>
          </el-col>
        </el-row>
      </template>
    </div>
  </el-form>
</template>

<script src="./player-setup-display.js"></script>
<style lang="scss" src="./player-setup-display.scss"></style>
